<template>
  <div class="available-checks-panel">
    <div class="mb-4">
      <input type="text" placeholder="Filter checks by name..." v-model="filterText"
             class="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
    </div>

    <div v-if="loading" class="text-center">
      <p>Loading available checks...</p>
      <!-- TODO: Add a spinner component -->
    </div>

    <div v-if="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
      <span class="block sm:inline">{{ error }}</span>
    </div>

    <div v-if="filteredChecks.length > 0" class="space-y-3 max-h-96 overflow-y-auto">
      <div v-for="check in filteredChecks" :key="check.id"
           class="p-3 bg-gray-50 rounded-md shadow-sm border border-gray-200 flex justify-between items-center">
        <div>
          <h4 class="font-semibold text-gray-800">{{ check.name }}</h4>
          <p class="text-sm text-gray-600 truncate" :title="check.description">{{ check.description }}</p>
        </div>
        <button @click="$emit('add-check', check)"
                class="ml-4 px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
          Add
        </button>
      </div>
    </div>
    <div v-else-if="!loading && !error">
      <p class="text-gray-500">No automated checks found{{ filterText ? ' matching your filter' : '' }}.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import api from '@/services/api'; // Changed from apiService

// eslint-disable-next-line no-unused-vars, no-undef
const emit = defineEmits(['add-check']);

const availableChecks = ref([]);
const loading = ref(false);
const error = ref(null);
const filterText = ref('');

async function fetchAvailableChecks() {
  loading.value = true;
  error.value = null;
  try {
    const response = await api.get('/automated-checks/'); // Changed from apiService
    availableChecks.value = response.data.automated_checks || response.data; // Adjust based on actual API response structure
  } catch (err) {
    console.error('Error fetching available automated checks:', err);
    error.value = 'Failed to load available checks.';
  } finally {
    loading.value = false;
  }
}

const filteredChecks = computed(() => {
  if (!filterText.value) {
    return availableChecks.value;
  }
  return availableChecks.value.filter(check => 
    check.name.toLowerCase().includes(filterText.value.toLowerCase())
  );
});

onMounted(() => {
  fetchAvailableChecks();
});

</script>

<style scoped>
/* Add any component-specific styles here */
</style> 